import * as ng from 'angular';

class ArchidriveRenameController implements ng.IController {

    static $inject: string[] = [
        '$scope',
        '$rootScope'
    ];

    private close: any;
    private dismiss: any;
    private item: any;

    constructor(
        private $scope: any,
        private $rootScope: any
    ) {
        this.item = $scope.$parent.$resolve.item;
        if (this.item.content_type !== 'application/x-www-form-urlencoded;charset=UTF-8' && this.item.name.indexOf('.') > -1) {
            $scope.name = this.item.name.substr(0, this.item.name.lastIndexOf('.'));
        } else {
            $scope.name = this.item.name;
        }

        $scope.namePattern = new RegExp('^[^\\\\/:*?"<>|]+$');
        $scope.rinomina = (errors) => {
            if ($.isEmptyObject(errors)) {

                if (this.item.content_type !== 'application/x-www-form-urlencoded;charset=UTF-8') {
                    let oldExtension = this.item.name.indexOf('.') > -1 ? this.item.name.split('.').pop() : '';

                    this.close({ $value: $scope.name + '.' + oldExtension });
                } else {
                    this.close({ $value: $scope.name });
                }
            } else {
                $rootScope.setErrorFieldsTouched(errors);
                $('[name=\'form\']').find('.ng-invalid:visible:first').focus();
            }
        };
        $scope.cancel = () => {
            this.dismiss();
        };
    }
}

export const ArchidriveRenameComponent: ng.IComponentOptions = {
    template: require('./archidrive-rename.html'),
    controller: ArchidriveRenameController,
    bindings: {
        close: '&',
        dismiss: '&'
    }
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/home/archidrive/archidrive-rename/archidrive-rename.ts